import { render, staticRenderFns } from "./HandoverFormDialog.vue?vue&type=template&id=a2bc1a5c&scoped=true"
import script from "./HandoverFormDialog.vue?vue&type=script&lang=js"
export * from "./HandoverFormDialog.vue?vue&type=script&lang=js"
import style0 from "./HandoverFormDialog.vue?vue&type=style&index=0&id=a2bc1a5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bc1a5c",
  null
  
)

export default component.exports